<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15">
    <g>
      <path d="M7 11l-3 3-3-3zM7 4L4 1 1 4z" />
    </g>
  </svg>
</template>
